import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { NgbDropdownModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap'
import { LocaleModule } from 'common/locale/module'
import { EntityListComponent, EntityListControlsDirective, EntityListEmptyDirective, EntityListFooterDirective, EntityListHeaderDirective, EntityListItemDirective } from './components/entityList.component'
import { UtilCommonModule } from 'common/util/module'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    UtilCommonModule,
    LocaleModule.forChild(),
    NgbDropdownModule,
    NgbPaginationModule,
  ],
  declarations: [
    EntityListComponent,
    EntityListItemDirective,
    EntityListEmptyDirective,
    EntityListHeaderDirective,
    EntityListFooterDirective,
    EntityListControlsDirective,
  ],
  exports: [
    EntityListComponent,
    EntityListItemDirective,
    EntityListEmptyDirective,
    EntityListHeaderDirective,
    EntityListFooterDirective,
    EntityListControlsDirective,
  ],
})
export class EntityListModule { }

export { Sort } from './components/entityList.component'
